import { LastViewedObject } from "../../types/types";
import List from "../List";
import Page from "../Page";
import useFetchPage from "../hooks/useFetchPage";

interface Props {
  setLastViewed: (value: LastViewedObject) => void;
}

const Logo = ({ setLastViewed }: Props) => {
  const page = useFetchPage(setLastViewed);

  return (
    page && (
      <Page title={page.frontmatter.title} description={page.content}>
        <List />
      </Page>
    )
  );
};

export default Logo;
